module.exports = __webpack_public_path__ + "static/img/9areaA_10.f07e714.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/9areaA_10.png
// module id = 831
// module chunks = 1